import { AbstractListService } from '@/core/services/list.service'
import { AbstractEditService } from '@/core/services/edit.service'
import { ListFetchOptions } from '@/core/typing'

class List extends AbstractListService<Store> {
  getFetchURL(): string {
    return 'role'
  }
}

class Edit extends AbstractEditService<Store> {
  getFetchURL() {
    return `role/${this.params.id}`
  }
  getSubmitURL(): string {
    return this.isEdit ? `role/${this.params.id}` : 'role'
  }
  getRemoveURL(): string {
    return `role/${this.params.id}`
  }
  requestListReload(option?: ListFetchOptions): void {
    this.context.list.fetch(option)
  }
}

class Store {
  list: List
  edit: Edit

  constructor() {
    this.list = new List(this)
    this.edit = new Edit(this)
  }
}

export const store = new Store()
